/**
 * Nav highlight sliding pill effect for the custom Okuma header.
 * Extracted from custom-header.js — this is the one unique behavior
 * not provided by Horizon's header.js / header-drawer.js.
 */
(function initNavHighlight() {
  const header = document.querySelector('header-component.custom-header');
  if (!header) return;

  const list = header.querySelector('[data-nav-list]');
  const highlight = header.querySelector('[data-nav-highlight]');
  if (!list || !highlight) return;

  const links = list.querySelectorAll('[data-nav-link]');
  if (!links.length) return;

  const setActiveLink = (link) => {
    links.forEach((l) => l.classList.toggle('is-highlighted', l === link));
  };

  const moveTo = (link) => {
    const linkRect = link.getBoundingClientRect();
    const listRect = list.getBoundingClientRect();
    const wasActive = highlight.classList.contains('is-active');

    // First entry into the nav from outside: snap to the new position with
    // no slide; subsequent moves between items animate normally.
    if (!wasActive) highlight.classList.add('is-snapping');

    highlight.style.setProperty('--nav-highlight-x', `${linkRect.left - listRect.left}px`);
    highlight.style.setProperty('--nav-highlight-w', `${linkRect.width}px`);
    highlight.classList.add('is-active');
    setActiveLink(link);

    if (!wasActive) {
      // Force reflow so the snap takes effect, then re-enable transitions
      // before the next frame so subsequent moves slide.
      void highlight.offsetWidth;
      requestAnimationFrame(() => highlight.classList.remove('is-snapping'));
    }
  };

  const hide = () => {
    highlight.classList.remove('is-active');
    setActiveLink(null);
  };

  const isFishlab = (link) =>
    !!link.closest('.custom-header__nav-item--fishlab');

  links.forEach((link) => {
    const handler = isFishlab(link) ? hide : () => moveTo(link);
    link.addEventListener('mouseenter', handler);
    link.addEventListener('focus', handler);
  });

  list.addEventListener('mouseleave', () => {
    if (list.querySelector('[data-mega-open]')) return;
    hide();
  });
  list.addEventListener('focusout', (event) => {
    if (!list.contains(event.relatedTarget)) hide();
  });

  document.addEventListener('okuma-mega:close', () => {
    if (list.matches(':hover')) return;
    if (list.contains(document.activeElement)) return;
    hide();
  });
})();
